import React, { useEffect, useState } from 'react';
import { Stack, IconButton } from '@mui/material';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';

import { TicketCompany, getTicketCompanyDetails } from '../../../../domain/tickets';
import { TravelPointLabel } from './travel-point-label';
import { TravelPoints } from '../../../../domain/travels';
import useLocation from '../../../../hooks/useLocation';

export const DEFAULT_TRAVEL_POINTS: TravelPoints<TicketCompany> = {
  origin: TicketCompany.Tijuana,
  destination: TicketCompany.SanDiego,
};

interface Props {
  onSwitch: (travelPoints: TravelPoints<TicketCompany>) => void;
  location: any
}


const TravelPointsSelector = ({ onSwitch, location }: Props) => {

  let defaultPoints = DEFAULT_TRAVEL_POINTS;
  if (location?.location?.request_country !== "MX") defaultPoints = {
    origin: TicketCompany.SanDiego,
    destination: TicketCompany.Tijuana
  };

  const [points, setPoints] = useState<TravelPoints<TicketCompany>>(defaultPoints);

  useEffect(() => {
    onSwitch(points);
  }, [])
  const handlePointsSiwtch = () => {
    setPoints((prev) => {
      const newPoints = { origin: prev.destination, destination: prev.origin };

      onSwitch(newPoints);

      return newPoints;
    });
  };

  return (
    <Stack position="relative" direction="row" gap="22px">
      <TravelPointLabel label={getTicketCompanyDetails(points.origin).place} isOrigin />
      <IconButton
        sx={{
          top: '11px',
          left: '112px',
          width: '40px',
          height: '28px',
          border: '1px solid rgba(186, 186, 186, 0.30)',
          position: 'absolute',
          borderRadius: '8px',
          backgroundColor: '#FFF',
          '&:hover': {
            backgroundColor: '#FFF',
          },
        }}
        onClick={handlePointsSiwtch}
      >
        <CompareArrowsIcon fontSize="medium" sx={{ color: '#EF60A3' }} />
      </IconButton>
      <TravelPointLabel label={getTicketCompanyDetails(points.destination).place} />
    </Stack>
  );
};
export const TravelPointsSwitcher = ({ onSwitch }: Props) => {
  const location = useLocation();

  let country = location?.location?.request_country ?? "US";

  return (
    <TravelPointsSelector key={`travel_point_switcher_${country}`} onSwitch={onSwitch} location={location} />
  );
};
